import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RESOURCE_LINKS = [
  { key: 'nav.spreadsheet', href: '#spreadsheet' },
  { key: 'nav.guides', href: '#guides' },
  { key: 'nav.reviews', href: '#features' },
  { key: 'nav.shipping', href: '#categories' },
  { key: 'nav.safety', href: '#safety' },
  { key: 'nav.faq', href: '#faq' },
];

const COMPANY_LINKS = [
  'footer.about',
  'footer.editorial',
  'footer.contact',
  'footer.disclaimer',
];

const LEGAL_LINKS = ['footer.privacy', 'footer.terms', 'footer.cookies'];

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'pl', label: 'Polski' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
];

export default function Footer() {
  const { t, i18n } = useTranslation();

  return (
    <footer className="bg-background-100 text-foreground-600">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg" />
              </span>
              <span className="font-heading text-base font-bold text-foreground-900 whitespace-nowrap">
                USFans <span className="text-primary-600">Spreadsheet</span>
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed">{t('footer.description')}</p>
            <p className="mt-4 max-w-sm text-xs leading-relaxed text-foreground-500">
              {t('footer.disclaimer_text')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">{t('footer.resources')}</h4>
            <ul className="mt-4 space-y-2.5">
              {RESOURCE_LINKS.map((item) => (
                <li key={item.key}>
                  <a href={item.href} className="text-sm transition-colors hover:text-primary-600 whitespace-nowrap">
                    {t(item.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">{t('footer.company')}</h4>
            <ul className="mt-4 space-y-2.5">
              {COMPANY_LINKS.map((key) => (
                <li key={key}>
                  <span className="text-sm text-foreground-500">{t(key)}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">{t('footer.legal')}</h4>
            <ul className="mt-4 space-y-2.5">
              {LEGAL_LINKS.map((key) => (
                <li key={key}>
                  <span className="text-sm text-foreground-500">{t(key)}</span>
                </li>
              ))}
            </ul>
            <h4 className="mt-6 text-sm font-semibold text-foreground-900">{t('footer.languages')}</h4>
            <div className="mt-3 flex flex-wrap gap-2">
              {LANGUAGES.map((lang) => (
                <button
                  key={lang.code}
                  type="button"
                  onClick={() => {
                    i18n.changeLanguage(lang.code);
                    document.documentElement.lang = lang.code;
                  }}
                  className={`rounded-full px-3 py-1 text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    i18n.language === lang.code
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-700 hover:bg-background-300'
                  }`}
                >
                  {lang.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">{t('footer.copyright')}</p>
          <p className="text-xs text-foreground-400">{t('footer.disclaimer')}</p>
        </div>
      </div>
    </footer>
  );
}